import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-tabs/style/react-tabs.css";
import BASE_URL from "../../../config/config";
// import "../../../css/admin.module.css";

const EditCourse = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    price: "0",
    is_free: false,
    is_available: true,
    cover_pic: null,
    intro_video: null,
    prerequisites: "",
    duration: "",
    level: "beginner",
    discount: "0",
  });

  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [csrfToken, setCsrfToken] = useState("");
  const [previewImage, setPreviewImage] = useState(null);
  const [currentCoverUrl, setCurrentCoverUrl] = useState("");

  const [sessions, setSessions] = useState([]);
  const [sessionForm, setSessionForm] = useState({
    title: "",
    description: "",
    file_url: null,
    is_available: true,
    is_free: false,
    duration: "",
  });
  const [sessionMessage, setSessionMessage] = useState("");
  const [sessionLoading, setSessionLoading] = useState(false);

  const [editingSession, setEditingSession] = useState(null);

  const [showDescriptionHTML, setShowDescriptionHTML] = useState(false);
  const [showSessionDescriptionHTML, setShowSessionDescriptionHTML] =
    useState(false);

  const handleToggleDescriptionHTML = () => {
    setShowDescriptionHTML((prev) => !prev);
  };

  const handleToggleSessionDescriptionHTML = () => {
    setShowSessionDescriptionHTML((prev) => !prev);
  };

  const textAreaRef = useRef(null); // اضافه شدن Ref به textarea
  const toolbarOptions = [
    [{ font: [] }, { size: [] }],
    [{ header: "1" }, { header: "2" }, { blockquote: true }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["link", "image"],
    ["code-block"],
    ["clean"],
  ];

  const modules = {
    toolbar: toolbarOptions,
  };

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(`${BASE_URL}/csrf-token`, {
          method: "GET",
          credentials: "include",
        });
        if (response.ok) {
          const data = await response.json();
          setCsrfToken(data.csrfToken);
        }
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };
    fetchCsrfToken();
  }, []);

  useEffect(() => {
    const fetchCourseData = async () => {
      setFetchLoading(true);
      try {
        const response = await fetch(`${BASE_URL}/courses/${id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          credentials: "include",
        });

        if (response.ok) {
          const responseData = await response.json();
          const data = responseData.data; // اینجا تغییر کرد

          setFormData({
            title: data.title || "",
            description: data.description || "",
            price: data.price || "0",
            is_free: data.is_free === 1, // تبدیل 1/0 به true/false
            is_available: data.is_available === 1, // تبدیل 1/0 به true/false
            prerequisites: data.prerequisites || "",
            duration: data.duration || "",
            level: data.level || "beginner",
            cover_pic: null,
            discount: data.discount || "0",
          });

          // نمایش تصویر فعلی
          if (data.cover_pic) {
            setCurrentCoverUrl(`${data.cover_pic}`); // اضافه کردن BASE_URL
          }
        } else {
          throw new Error("خطا در دریافت اطلاعات دوره");
        }
      } catch (error) {
        setMessage(error.message);
      } finally {
        setFetchLoading(false);
      }
    };

    if (id) {
      fetchCourseData();
    }
  }, [id]);

  // اضافه کردن useEffect جدید برای دریافت جلسات
  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const response = await fetch(`${BASE_URL}/courses/${id}/sessions`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          credentials: "include",
        });

        if (response.ok) {
          const data = await response.json();
          setSessions(data.data);
        }
      } catch (error) {
        setSessionMessage("خطا در دریافت لیست جلسات");
      }
    };

    if (id) {
      fetchSessions();
    }
  }, [id]);

  // تابع برای شروع ویرایش جلسه
  const handleEditSession = (session) => {
    setEditingSession(session);
    setSessionForm({
      title: session.title,
      description: session.description,
      duration: session.duration,
      is_available: session.is_available === 1,
      is_free: session.is_free === 1,
      file_url: null, // فایل جدید
    });
  };

  // تابع برای لغو ویرایش
  const handleCancelEdit = () => {
    setEditingSession(null);
    setSessionForm({
      title: "",
      description: "",
      file_url: null,
      is_available: true,
      is_free: false,
      duration: "",
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      const file = files[0];
      if (file) {
        setFormData((prev) => ({
          ...prev,
          [name]: file,
        }));
        // برای پیش‌نمایش تصویر جدید
        if (name === "cover_pic") {
          const reader = new FileReader();
          reader.onloadend = () => {
            setPreviewImage(reader.result);
          };
          reader.readAsDataURL(file);
        }
      }
    } else if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
      // اگر رایگان شد، قیمت را صفر کن
      if (name === "is_free" && checked) {
        setFormData((prev) => ({
          ...prev,
          price: "0",
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // محاسبه قیمت نهایی با تخفیف
  const calculateFinalPrice = () => {
    const price = parseFloat(formData.price) || 0;
    const discount = parseFloat(formData.discount) || 0;
    return price - (price * discount) / 100;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        // فقط اگر cover_pic جدید انتخاب شده باشد آن را ارسال کن
        if (key === "cover_pic" && formData[key] === null) {
          return;
        }
        formDataToSend.append(key, formData[key]);
      });

      const response = await fetch(`${BASE_URL}/courses/${id}`, {
        method: "PUT",
        headers: {
          "CSRF-Token": csrfToken,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
        body: formDataToSend,
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("دوره با موفقیت بروزرسانی شد");
        setTimeout(() => {
          navigate("/admin/courses/list");
        }, 2000);
      } else {
        throw new Error(data.message || "خطا در بروزرسانی دوره");
      }
    } catch (error) {
      setMessage(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSessionChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      setSessionForm((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    } else if (type === "checkbox") {
      setSessionForm((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      setSessionForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // تغییر در تابع handleSessionSubmit
  const handleSessionSubmit = async (e) => {
    e.preventDefault();
    setSessionLoading(true);
    setSessionMessage("");

    try {
      const formData = new FormData();
      Object.keys(sessionForm).forEach((key) => {
        if (key === "file_url" && !sessionForm[key]) return;
        formData.append(key, sessionForm[key]);
      });

      const url = editingSession
        ? `${BASE_URL}/sessions/${editingSession.id}`
        : `${BASE_URL}/courses/${id}/sessions`;

      const method = editingSession ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: {
          "CSRF-Token": csrfToken,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        setSessionMessage(
          editingSession
            ? "جلسه با موفقیت ویرایش شد"
            : "جلسه با موفقیت اضافه شد"
        );

        // بروزرسانی لیست جلسات
        const sessionsResponse = await fetch(
          `${BASE_URL}/courses/${id}/sessions`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            credentials: "include",
          }
        );
        const sessionsData = await sessionsResponse.json();
        setSessions(sessionsData.data);

        // پاک کردن فرم و خروج از حالت ویرایش
        handleCancelEdit();
      } else {
        throw new Error(data.message || "خطا در عملیات");
      }
    } catch (error) {
      setSessionMessage(error.message);
    } finally {
      setSessionLoading(false);
    }
  };

  const handleDeleteSession = async (sessionId) => {
    if (!window.confirm("آیا از حذف این جلسه اطمینان دارید؟")) {
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/sessions/${sessionId}`, {
        method: "DELETE",
        headers: {
          "CSRF-Token": csrfToken,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
      });

      if (response.ok) {
        setSessions(sessions.filter((session) => session.id !== sessionId));
        setSessionMessage("جلسه با موفقیت حذف شد");
      } else {
        throw new Error("خطا در حذف جلسه");
      }
    } catch (error) {
      setSessionMessage(error.message);
    }
  };

  if (fetchLoading) {
    return (
      <div className="loading-container">در حال بارگذاری اطلاعات دوره...</div>
    );
  }

  return (
    <div className="edit-course-container">
      <h2>ویرایش دوره</h2>
      <Tabs>
        <TabList>
          <Tab>اطلاعات دوره</Tab>
          <Tab>جلسات دوره</Tab>
        </TabList>

        <TabPanel>
          <form onSubmit={handleSubmit} className="edit-course-form">
            <div className="form-group">
              <label htmlFor="title">عنوان دوره:</label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="description">توضیحات دوره:</label>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  handleToggleDescriptionHTML();
                }}
                style={{ marginBottom: "10px" }}
              >
                {showDescriptionHTML ? "بازگشت به ویرایشگر" : "نمایش HTML"}
              </button>

              {showDescriptionHTML ? (
                <textarea
                  id="description"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                  style={{
                    width: "100%",
                    height: "200px",
                    fontFamily: "monospace",
                    fontSize: "14px",
                  }}
                ></textarea>
              ) : (
                <ReactQuill
                  id="description"
                  theme="snow"
                  value={formData.description}
                  onChange={(value) =>
                    setFormData((prev) => ({
                      ...prev,
                      description: value,
                    }))
                  }
                  modules={modules}
                />
              )}
            </div>

            <div className="form-group">
              <label htmlFor="cover_pic">تصویر دوره:</label>
              {currentCoverUrl && !previewImage && (
                <div className="current-image">
                  <p>تصویر فعلی:</p>
                  <img src={currentCoverUrl} alt="تصویر فعلی دوره" />
                </div>
              )}
              <input
                type="file"
                id="cover_pic"
                name="cover_pic"
                accept="image/*"
                onChange={handleChange}
              />
              {previewImage && (
                <div className="image-preview">
                  <p>تصویر جدید:</p>
                  <img src={previewImage} alt="پیش‌نمایش تصویر جدید" />
                </div>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="intro_video">ویدیوی معرفی:</label>
              <input
                type="file"
                id="intro_video"
                name="intro_video"
                accept="video/*"
                onChange={handleChange}
              />
            </div>

            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  name="is_free"
                  checked={formData.is_free}
                  onChange={handleChange}
                />
                دوره رایگان است
              </label>
            </div>

            {!formData.is_free && (
              <>
                <div className="form-group">
                  <label htmlFor="price">قیمت دوره (تومان):</label>
                  <input
                    type="number"
                    id="price"
                    name="price"
                    value={formData.price}
                    onChange={handleChange}
                    min="0"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="discount">تخفیف (درصد):</label>
                  <input
                    type="number"
                    id="discount"
                    name="discount"
                    value={formData.discount}
                    onChange={handleChange}
                    min="0"
                    max="100"
                    step="0.01"
                    placeholder="0 تا 100"
                  />
                  {parseFloat(formData.discount) > 0 && (
                    <div className="discount-info">
                      <p>
                        قیمت اصلی: {parseFloat(formData.price).toLocaleString()}{" "}
                        تومان
                      </p>
                      <p>تخفیف: {formData.discount}%</p>
                      <p className="final-price">
                        قیمت نهایی: {calculateFinalPrice().toLocaleString()}{" "}
                        تومان
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}

            <div className="form-group">
              <label htmlFor="prerequisites">پیش‌نیازها:</label>
              <textarea
                id="prerequisites"
                name="prerequisites"
                value={formData.prerequisites}
                onChange={handleChange}
                rows="3"
              />
            </div>
            <div className="form-group">
              <label htmlFor="duration">مدت زمان دوره:</label>
              <input
                type="text"
                id="duration"
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                placeholder="مثال: 20 ساعت"
              />
            </div>

            <div className="form-group">
              <label htmlFor="level">سطح دوره:</label>
              <select
                id="level"
                name="level"
                value={formData.level}
                onChange={handleChange}
              >
                <option value="beginner">مقدماتی</option>
                <option value="intermediate">متوسط</option>
                <option value="advanced">پیشرفته</option>
              </select>
            </div>

            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  name="is_available"
                  checked={formData.is_available}
                  onChange={handleChange}
                />
                دوره در دسترس است
              </label>
            </div>

            {message && (
              <div
                className={
                  message.includes("موفقیت")
                    ? "success-message"
                    : "error-message"
                }
              >
                {message}
              </div>
            )}

            <button type="submit" disabled={isLoading}>
              {isLoading ? "در حال ذخیره..." : "ذخیره تغییرات"}
            </button>
          </form>
        </TabPanel>

        <TabPanel>
          <div className="sessions-container">
            <h3>مدیریت جلسات دوره</h3>

            {/* لیست جلسات */}
            <div className="sessions-list">
              <table>
                <thead>
                  <tr>
                    <th>عنوان جلسه</th>
                    <th>مدت زمان</th>
                    <th>وضعیت</th>
                    <th>دسترسی</th>
                    <th>عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  {sessions.map((session) => (
                    <tr key={session.id}>
                      <td>{session.title}</td>
                      <td>{session.duration || "-"}</td>
                      <td>
                        <span
                          className={`status ${
                            session.is_available ? "active" : "inactive"
                          }`}
                        >
                          {session.is_available ? "فعال" : "غیرفعال"}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`access ${
                            session.is_free ? "free" : "paid"
                          }`}
                        >
                          {session.is_free ? "رایگان" : "نقدی"}
                        </span>
                      </td>
                      <td className="action-buttons">
                        <button
                          onClick={() => handleEditSession(session)}
                          className="edit-btn"
                          title="ویرایش جلسه"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          onClick={() => handleDeleteSession(session.id)}
                          className="delete-btn"
                          title="حذف جلسه"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* فرم افزودن جلسه */}
            <div className="add-session-form">
              <h4>{editingSession ? "ویرایش جلسه" : "افزودن جلسه جدید"}</h4>
              <form onSubmit={handleSessionSubmit}>
                <div className="form-group">
                  <label htmlFor="session-title">عنوان جلسه:</label>
                  <input
                    type="text"
                    id="session-title"
                    name="title"
                    value={sessionForm.title}
                    onChange={handleSessionChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="session-description">توضیحات جلسات:</label>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleToggleSessionDescriptionHTML();
                    }}
                    style={{ marginBottom: "10px" }}
                  >
                    {showSessionDescriptionHTML
                      ? "بازگشت به ویرایشگر"
                      : "نمایش HTML"}
                  </button>

                  {showSessionDescriptionHTML ? (
                    <textarea
                      id="session-description"
                      value={sessionForm.description}
                      onChange={(e) =>
                        setSessionForm((prev) => ({
                          ...prev,
                          description: e.target.value,
                        }))
                      }
                      style={{
                        width: "100%",
                        height: "200px",
                        fontFamily: "monospace",
                        fontSize: "14px",
                      }}
                    ></textarea>
                  ) : (
                    <ReactQuill
                      id="session-description"
                      theme="snow"
                      value={sessionForm.description}
                      onChange={(value) =>
                        setSessionForm((prev) => ({
                          ...prev,
                          description: value,
                        }))
                      }
                      modules={modules}
                    />
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="session-file">فایل جلسه:</label>
                  <input
                    type="file"
                    id="session-file"
                    name="file_url"
                    onChange={handleSessionChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="session-duration">مدت زمان (دقیقه):</label>
                  <input
                    type="number"
                    id="session-duration"
                    name="duration"
                    value={sessionForm.duration}
                    onChange={handleSessionChange}
                    min="1"
                  />
                </div>

                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="is_free"
                      checked={sessionForm.is_free}
                      onChange={handleSessionChange}
                    />
                    جلسه رایگان است
                  </label>
                </div>

                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="is_available"
                      checked={sessionForm.is_available}
                      onChange={handleSessionChange}
                    />
                    جلسه در دسترس است
                  </label>
                </div>

                {sessionMessage && (
                  <div
                    className={
                      sessionMessage.includes("موفقیت")
                        ? "success-message"
                        : "error-message"
                    }
                  >
                    {sessionMessage}
                  </div>
                )}

                <div className="form-buttons">
                  <button type="submit" disabled={sessionLoading}>
                    {sessionLoading
                      ? editingSession
                        ? "در حال ویرایش..."
                        : "در حال افزودن..."
                      : editingSession
                      ? "ذخیره تغییرات"
                      : "افزودن جلسه"}
                  </button>

                  {editingSession && (
                    <button
                      type="button"
                      onClick={handleCancelEdit}
                      className="cancel-btn"
                    >
                      انصراف
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default EditCourse;
